import { FC } from 'react';
import { Col } from 'shared/ui/Col';
import { RectSkeleton } from 'shared/ui/Skeleton/RectSkeleton';

export const BuildingsDetailsSkeleton: FC = () => {
  return (
    <Col spacing={9} maxWidth={'lg'} sx={{ m: 'auto' }}>
      <RectSkeleton width={170} height={37} />
      <RectSkeleton width={606} height={280} />
    </Col>
  );
};
